export const API_SYNC_REPORTING_ASSESSMENT_PATH_KEY = '/sync-reporting-assessment';
export const API_SYNC_REPORTING_TRAINING_PATH_KEY = '/sync-reporting-training';
export const API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_PATH_KEY =
  '/organizations/{organizationId}/reports/assessment';
export const API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_EXPORT_PATH_KEY =
  '/organizations/{organizationId}/reports/assessment/export';
export const API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_PATH_KEY =
  '/organizations/{organizationId}/reports/training';
export const API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_TRAINING_EXPORT_PATH_KEY =
  '/organizations/{organizationId}/reports/training/export';
